const MovementRoutes = [
    {
      path: "/movements",
      name: "Movements",
      component: () => import("@/pages/movements/MovementListPage.vue"),
      meta: {
        auth: true,
        permission: {
          act: 'create', on: 'Movement'
        }
      },
      children: [
        // {
        //   path: "new",
        //   name: "NewMovement",
        //   // component: () => import("@/pages/movements/NewMovementPage.vue"),
        //   meta: {
        //     auth: true
        //   }
        // },
        {
          path: ":id",
          name: "ShowMovement",
          component: () => import("@/pages/movements/ShowMovementPage.vue"),
          meta: {
            auth: true,
            permission: {
              act: 'create', on: 'Movement'
            }
          }
        },
      ]
    },
  ]
  
  export default MovementRoutes